import axios from 'axios';
import { useState, useEffect } from 'react';
import './today.css';
import { AgendaItem } from './agenda';
import { formatDateToLocale, get } from './utils/utils';
import { useAuth } from '../context/context';

export function Today() {

    const [agendaItems, setAgendaItems] = useState<AgendaItem[]>([]);
    const currentDate = new Date();
    const { user } = useAuth()

    useEffect(() => {
        get({
            url: 'agendaActiveItems.php',
            token: user.token,
          })
            .then((response) => response.data)
            .then((data) => {
              console.log('Items: ', data);
              const items: AgendaItem[] = data.map((item: any) => {
                const startDate = new Date(item.startDate);
                const endDate = item.endDate ? new Date(item.endDate) : '';
                const offsetStartDate = new Date(startDate.getTime() + Math.abs(startDate.getTimezoneOffset()*60000)) 
                const offsetEndDate = endDate ? new Date(endDate.getTime() + Math.abs(endDate.getTimezoneOffset()*60000)) : ''
                return {
                    id: item.id,
                    startTime: item.startTime,
                    content: item.content,
                    startDate: offsetStartDate,
                    endDate: offsetEndDate,
                    endTime: item.endTime
                }
            });
              setAgendaItems(items);
            })
            .catch((error) => {
              console.error('Error fetching items:', error);
            });
    }, []);

    return (
        <div className='today-container'>
            <div className='today-header'>
                <p><strong>{agendaItems.length}</strong> EVENTOS</p>
                <p>{currentDate.toLocaleString('es-mx', { weekday: 'long'}).toUpperCase()} <strong>{currentDate.getDate()}</strong> {currentDate.toLocaleString('es-mx', { month: 'long'}).toUpperCase()}</p>
            </div>
            <div className='today-events'>
                <table>
                {agendaItems && agendaItems.map((item) => 
                    <tr key={item.id}>
                        <td>{item.startDate && item.endDate && "Del"} {formatDateToLocale(item.startDate!)}</td>
                        <td>{item.startTime === '0:00' || item.startTime === undefined || !item.startTime ? '' : item.startTime + ' Hr'}</td>
                        <td>{item.content}</td>
                        <td>{item.endDate ? 'Al ' + formatDateToLocale(item.endDate) : ''}</td>
                        <td>{item.endTime === '0:00' || item.endTime === undefined || !item.endTime ? '' : item.endTime  + ' Hr'}</td>
                    </tr>
                )}
                {agendaItems.length < 15 && [...Array(15 - agendaItems.length)].map((x, i) =>
                    <tr key={i}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                )}
                </table>
            </div>
        </div>
    )
}